import stones from "../../api/stones";
import i18n from '../../i18n.js' 

const state = () => ({
  results: [],
  isLoading: true,
  selectedStone: {},
  total: 0,
  query: {},
  shapes: [
    { value: 'ROUND', active: false },
    { value: 'PRINCESS', active: false },
    { value: 'CUSHION', active: false },
    { value: 'OVAL', active: false },
    { value: 'PEAR', active: false },
    { value: 'EMERALD', active: false },
    { value: 'HEART', active: false },
    { value: 'RADIANT', active: false },
    { value: 'ASSCHER', active: false },
    { value: 'MARQUISE', active: false },
    //{ value: 'SHIELD', active: false },
    { value: 'TRIANGULAR', active: false },
  ],
  fancyOvertoneOptions: [
    { value: "None", label: i18n.t("fancy_overtone.none") },
    { value: "Yellow", label: i18n.t("fancy_overtone.yellow") },
    { value: "Yellowish", label: i18n.t("fancy_overtone.yellowish") },
    { value: "Pink", label: i18n.t("fancy_overtone.pink") },
    { value: "Pinkish", label: i18n.t("fancy_overtone.pinkish") },
    { value: "Blue", label: i18n.t("fancy_overtone.blue") },
    { value: "Blueish", label: i18n.t("fancy_overtone.blueish") },
    { value: "Red", label: i18n.t("fancy_overtone.red") },
    { value: "Reddish", label: i18n.t("fancy_overtone.reddish") },
    { value: "Green", label: i18n.t("fancy_overtone.green") },
    { value: "Greenish", label: i18n.t("fancy_overtone.greenish") },
    { value: "Purple", label: i18n.t("fancy_overtone.purple") },
    { value: "Purplish", label: i18n.t("fancy_overtone.purplish") },
    { value: "Orange", label: i18n.t("fancy_overtone.orange") },
    { value: "Orangey", label: i18n.t("fancy_overtone.orangey") },
    { value: "Violet", label: i18n.t("fancy_overtone.violet") },
    { value: "Gray", label: i18n.t("fancy_overtone.gray") },
    { value: "Grayish", label: i18n.t("fancy_overtone.grayish") },
    { value: "Black", label: i18n.t("fancy_overtone.black") },
    { value: "Brown", label: i18n.t("fancy_overtone.brown") },
    { value: "Brownish", label: i18n.t("fancy_overtone.brownish") },
    { value: "Champagne", label: i18n.t("fancy_overtone.champagne") },
    { value: "Cognac", label: i18n.t("fancy_overtone.cognac") },
    { value: "Chameleon", label: i18n.t("fancy_overtone.chameleon") },
    { value: "White", label: i18n.t("fancy_overtone.white") },
    { value: "Other", label: i18n.t("fancy_overtone.other") }
  ],
  fancyColorOptions: [
    { value: "Yellow", label: i18n.t("fancy_color.yellow") },
    { value: "Pink", label: i18n.t("fancy_color.pink") },
    { value: "Blue", label: i18n.t("fancy_color.blue") },
    { value: "Red", label: i18n.t("fancy_color.red") },
    { value: "Green", label: i18n.t("fancy_color.green") },
    { value: "Purple", label: i18n.t("fancy_color.purple") },
    { value: "Orange", label: i18n.t("fancy_color.orange") },
    { value: "Violet", label: i18n.t("fancy_color.violet") },
    { value: "Gray", label: i18n.t("fancy_color.gray") },
    { value: "Black", label: i18n.t("fancy_color.black") },
    { value: "Brown", label: i18n.t("fancy_color.brown") },
    { value: "Champagne", label: i18n.t("fancy_color.champagne") },
    { value: "Cognac", label: i18n.t("fancy_color.cognac") },
    { value: "Chameleon", label: i18n.t("fancy_color.chameleon") },
    { value: "White", label: i18n.t("fancy_color.white") },
    { value: "Other", label: i18n.t("fancy_color.other") }
  ],
  fancyIntensityOptions: [
    { value: "Faint", label: i18n.t("fancy_intensity.faint") },
    { value: "Very_Light", label: i18n.t("fancy_intensity.very_light") },
    { value: "Light", label: i18n.t("fancy_intensity.light") },
    { value: "Fancy_Light", label: i18n.t("fancy_intensity.fancy_light") },
    { value: "Fancy", label: i18n.t("fancy_intensity.fancy") },
    { value: "Fancy_Dark", label: i18n.t("fancy_intensity.fancy_dark") },
    { value: "Fancy_Intense", label: i18n.t("fancy_intensity.fancy_intense") },
    { value: "Fancy_Vivid", label: i18n.t("fancy_intensity.fancy_vivid") },
    { value: "Fancy_Deep", label: i18n.t("fancy_intensity.fancy_deep") },
  ],
  certificateLab: ["IGI", "GIA", "HRD", "EGL"],
});

// getters
const getters = {
  getQuery(state) {
    return state.query;
  },
};

// actions
const actions = {
  fetchResults({ commit }, search) {
    commit("setIsLoading", true);
    stones.search(search).then((data) => {
      commit("setResults", data.data?.items);
      commit("setIsLoading", false);
      search.cb();
    }).catch(error => {
      commit("setIsLoading", false);
      search.cb();
    })
  },

  initResults({ commit, dispatch }, search) {
    commit("setIsLoading", true);
    Promise.all([stones.count(search), stones.search(search)]).then(values => {
      commit("setTotal", values[0].data);
      commit("setResults", values[1].data?.items);
      commit("setIsLoading", false);
      search.cb();
    }).catch(error => {
      commit("setIsLoading", false);
      search.cb();
    })
  },

  selectStone({ commit }, stone) {
    commit("setSelectedStone", stone);
  },

  setQuery({ commit }, query) {
    commit("setQuery", query);
  },

  resetResults({ commit }) {
    commit("setResults", []);
  },
};

// mutations
const mutations = {
  setResults(state, value) {
    state.results = value;
  },
  setIsLoading(state, value) {
    state.isLoading = value;
  },
  setSelectedStone(state, value) {
    state.selectedStone = value;
  },
  setTotal(state, value) {
    state.total = value;
  },
  setQuery(state, value) {
    state.query = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
